import { Link, useNavigate } from 'react-router-dom';

import { useAuth } from '../../features/auth/useAuth';
import { useProfile } from '../../features/settings/settings-api';
import { ROLE_LABELS } from '../../lib/labels';
import { LogoutIcon } from '../icons';
import { Money } from '../ui/Money';
import { Skeleton } from '../ui/Skeleton';
import { Brand } from './Brand';

export function TopBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const isPlayer = Boolean(user?.playerId);
  const profile = useProfile(isPlayer);

  const onLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="sticky top-0 z-30 border-b border-line bg-surface/95 backdrop-blur">
      <div className="flex min-w-0 items-center gap-3 px-4 py-2.5 sm:px-6 lg:px-8">
        <Link to="/" className="min-w-0 shrink lg:hidden" aria-label="RoboMiD — на главную">
          <Brand />
        </Link>

        <div className="hidden min-w-0 flex-col lg:flex">
          <span className="truncate text-sm font-semibold text-ink">{user?.name}</span>
          <span className="text-xs text-ink-faint">{user ? ROLE_LABELS[user.role] : ''}</span>
        </div>

        <div className="ml-auto flex min-w-0 shrink-0 items-center gap-2">
          {isPlayer ? (
            <Link
              to="/balance"
              className="flex max-w-[9.5rem] min-h-11 min-w-0 items-center gap-2 rounded-control bg-[#E3F1E8] px-3 sm:max-w-none"
            >
              <span className="text-xs text-ink-faint">Баланс</span>
              {profile.isPending ? (
                <Skeleton className="h-4 w-16" />
              ) : (
                <Money value={profile.data?.balance} tone="brand" className="font-semibold" />
              )}
            </Link>
          ) : null}
          <button
            type="button"
            onClick={() => void onLogout()}
            aria-label="Выйти"
            title="Выйти"
            className="grid size-11 place-items-center rounded-control border border-line bg-surface text-ink-muted hover:text-negative"
          >
            <LogoutIcon className="size-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
